import { fetcher } from "helpers/fetcher";

import {
  TDeleteJobListingRequirementsReq,
  TDeleteJobListingRequirementsRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteJobListingExperience = async (
  payload: TDeleteJobListingRequirementsReq
) => {
  return await fetcher<
    TDeleteJobListingRequirementsRes,
    TDeleteJobListingRequirementsReq["data"]
  >(ENDPOINT.CORPORATION.DELETE_JOB_LISTING_EXPERIENCE, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.DELETE_JOB_LISTING_EXPERIENCE.version,
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
  });
};

export const mutationDeleteJobListingExperience = async (
  payload: TDeleteJobListingRequirementsReq
) => {
  return (await deleteJobListingExperience(payload)).data;
};

mutationDeleteJobListingExperience._key = (
  payload: TDeleteJobListingRequirementsReq
) => [ENDPOINT.CORPORATION.DELETE_JOB_LISTING_EXPERIENCE.url, payload];
